export default "__VITE_ASSET__2MVdtxwz__"